import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useOptions} from './';

const defaultOptions = {
    site: 'homeaway_us',
    baseUrl: 'https://www.homeaway.com',
    appPrefix: '/',
    pageType: undef,
    locale: 'en_US'
};

function useSystemOptions(props) {
    const {
        systemOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useSystemOptions};
